import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ImpressumPage } from './pages/ImpressumPage';
import { DatenschutzPage } from './pages/DatenschutzPage';
import { KostenloseDemoPage } from './pages/KostenloseDemoPage';
import { KraftCrmPage } from './pages/KraftCrmPage';
import { ScrollToTop } from './components/ScrollToTop';
import { LanguageProvider } from './contexts/LanguageContext';
export function App() {
  return <LanguageProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<KraftCrmPage data-id="element-5" />} data-id="element-4" />
          <Route path="/impressum" element={<ImpressumPage data-id="element-7" />} data-id="element-6" />
          <Route path="/datenschutz" element={<DatenschutzPage data-id="element-9" />} data-id="element-8" />
          <Route path="/kostenlose-demo" element={<KostenloseDemoPage data-id="element-11" />} data-id="element-10" />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>;
}